import Api from "../../services/Api"

const api = Api.getInstance()

interface WalkTypeInterface {
  title: string,
  subtitle: string,
  pro: boolean,
  icon: string,
  slides?: Array<number>
  data?: any
}

// slides
// 0 - Preview Last slide
// 1 - Map
// 2 - Time
// 3 - Type walk / audio
// 4 - Network picker
// 5 - Person invite
// 6 - Category
// 7 - Repeat
// 8 - Group
// 9 - Day
// 10 - Time

export const walkTypes = <Array<WalkTypeInterface>> [
  {
    title: api.tr('OpenNetwork_button'),
    subtitle: api.tr('OpenNetwork_description'),
    pro: false,
    icon: 'eyeOutline',
    slides: [10,3,1,0]
  },
  {
    title: 'Audio',
    subtitle: api.tr('AudioWalk_Description'),
    pro: false,
    icon: 'mic',
    slides: [10,0],
    data: {
      hasTalk: true,
      hasCoordinates: false
    }
  }, 
  {
    title: api.tr('Network_Button'),
    subtitle: api.tr('Network_Description'),
    pro: true,
    icon: 'walkIcon',
    slides: [4,10,3,1,0]
  },
  {
    title: api.tr('Group_button'),
    subtitle: api.tr('Group_description'),
    pro: true,
    icon: 'people',
    slides: [10,8,3,1,0],
    data: {
      max_bookings: 4
    }
  },
  {
    title: api.tr('Invite_button'),
    subtitle: api.tr('Invite_description'),
    pro: true,
    icon: 'person',
    slides: [5,10,3,1,0]
  }, 
  {
    title: api.tr('Private_button'),
    subtitle: api.tr('Private_Description'),
    pro: true,
    slides: [10,3,1,0], 
    icon: 'lockClosed',
    data: {
      invite_only: true
    }
  },
  {
    title: api.tr('Profilebutton_button'),
    subtitle: api.tr('Profilebutton_description'),
    pro: true,
    slides: [10,3,1,0], 
    icon: 'eye',
    data: {
      profile_only: true
    }
  }, {
    title: 'Repeat',
    subtitle: api.tr('Repeat_description'),
    pro: true,
    icon: 'repeat',
    slides: [7, 3, 0]
  }
]